import React from 'react';

import WistiaPopover from '@components/WistiaPopover/WistiaPopover';

import {
  ClassesPageRecordedClassCardDIV,
} from './ClassesPageRecordedClassCard.styles';

const ClassesPageRecordedClassCard = ({
  description,
  tag,
  title,
  wistiaId,
  wistiaPreviewImage,
  wistiaVideoLength,
}) => (
  <ClassesPageRecordedClassCardDIV>
    <WistiaPopover
      id={wistiaId}
      imageData={wistiaPreviewImage?.imgixImage?.gatsbyImageData}
      imageAlt={title}
    />
    <span className="font-family--mono font-size--S">{tag}</span>
    <h6>{title}</h6>
    <p className="font--text-S">{description}</p>
  </ClassesPageRecordedClassCardDIV>
);

export default ClassesPageRecordedClassCard;